import { Reveal, SectionLabel } from "./ui";
import RichHTML from "../RichHTML";
import { Quote } from "lucide-react";

export default function PartnerVoices({ items = [], index, appr }) {
  if (!items.length) return null;
  return (
    <section style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <Reveal><SectionLabel index={index}>Was meine Partner sagen</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)] max-w-2xl">
            Stimmen aus der <span className="font-medium">Zusammenarbeit</span>.
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <Reveal key={t.id || i} delay={i * 0.1}>
              <figure data-testid={`partnervoice-${i}`} className="h-full bg-white border border-[var(--mf-line)] p-8 flex flex-col">
                {t.quote && (
                  <>
                    <Quote size={28} className="text-[var(--mf-red)]" />
                    <blockquote className="mt-4 text-[1.125em] leading-relaxed text-[var(--mf-ink)] font-light flex-1">
                      <RichHTML html={t.quote} />
                    </blockquote>
                  </>
                )}
                <figcaption className="mt-auto pt-5 border-t border-[var(--mf-line)] flex items-center gap-4">
                  {t.image && (
                    <img
                      src={t.image}
                      alt={t.author}
                      data-testid={`partnervoice-avatar-${i}`}
                      className="h-14 w-14 rounded-full object-contain bg-white p-1 ring-1 ring-[var(--mf-line)] shrink-0"
                    />
                  )}
                  <div>
                    <div className="font-head font-semibold text-[var(--mf-ink)]">{t.author}</div>
                    <div className="text-sm text-[var(--mf-grey)]">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
